import React, { useEffect } from 'react'
import Modal from 'react-modal'

const ImageModal = (props) => {
    const [modalIsOpen, setIsOpen] = React.useState(false);

    useEffect(() => {
        console.log(props.isOpen);
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    const customStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.3)"
        },
        content: {
          top: '60px',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, 0%)',
          boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.2)',
          minWidth: '320px',
          maxWidth: '85%',
          borderRadius: '10px',
        },
    };

  return (
    <Modal
        contentLabel="画像"
        style={customStyles}
        isOpen={modalIsOpen}
    >
        <button onClick={() => props.onClose()} className='absolute top-4 end-4 text-xl text-gray-500'><i className='bi bi-x-lg'></i></button>
        
        {props.url && (
            <div className='my-3 mt-8'>
                <img src={props.url} alt='画像' className='max-w-full max-h-96 rounded' />
            </div>
        )}
        
    </Modal>
  )
}

export default ImageModal